// From chatgpt
function replaceAcronymsInElement(element, acronyms) {
  // Map pour recherche insensible à la casse
  const lowerMap = new Map(
    Object.entries(acronyms).map(([k, v]) => [k.toLowerCase(), v])
  );
  // REGEXP SIMPLIFIÉE car les clés sont [a-zA-Z0-9] uniquement
  const pattern = new RegExp(`\\b(${Object.keys(acronyms).join('|')})\\b`, 'gi');
  // Balises interdites
  const forbidden = new Set(['ABBR', 'SCRIPT', 'STYLE', 'TITLE', 'NOSCRIPT', 'BUTTON']);

  function processNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      let text = node.nodeValue;
      let replaced = false;
      text = text.replace(pattern, (match) => {
        const def = lowerMap.get(match.toLowerCase());
        if (!def) return match;
        replaced = true;
        return `<span data-bs-toggle="tooltip" title="${def.replace(/"/g, '&quot;')}">${match}</span>`;
      });
      if (replaced) {
        const temp = document.createElement('span');
        temp.innerHTML = text;
        const frag = document.createDocumentFragment();
        while (temp.firstChild) frag.appendChild(temp.firstChild);
        node.parentNode.replaceChild(frag, node);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE && !forbidden.has(node.tagName)) {
      Array.from(node.childNodes).forEach(processNode);
    }
  }
  processNode(element);
}

document.addEventListener("DOMContentLoaded", function () {
    if (typeof acronyms !== 'object') return;
    if (Object.keys(acronyms).length === 0) return;
    let content = document.getElementById('preview');
    if (!content) return;
    replaceAcronymsInElement(content, acronyms);

    // Lancer les tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
});
